<template>

 <pdf class="documento"
  :src="documento"

  ></pdf>
</div>

</template>

<script>
import pdf from 'vue-pdf'

export default {
   data() {
    return {
      documento: "http://cimogsys.espoch.edu.ec/geoportal_files/DOCUMENTOS/"+this.$route.params.doc+ ".pdf"
    }
  },
  components: {
    pdf
  }
}
</script>

<style lang="scss" scoped src="../sass/about.scss"></style>


// WEBPACK FOOTER //
// src/components/about.vue